// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { DataCacheProvider } from './context/DataCacheContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Overview from './pages/Overview';
import Positions from './pages/Positions';
import TradeHistory from './pages/TradeHistory';
import SymbolAnalysis from './pages/SymbolAnalysis';
import Performance from './pages/Performance';
import Login from './pages/Login';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <AuthProvider>
      <DataCacheProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Routes>
                      <Route path="/" element={<Overview />} />
                      <Route path="/positions" element={<Positions />} />
                      <Route path="/trades" element={<TradeHistory />} />
                      <Route path="/symbols" element={<SymbolAnalysis />} />
                      <Route path="/performance" element={<Performance />} />
                    </Routes>
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Router>
      </DataCacheProvider>
    </AuthProvider>
  );
}

export default App;